import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import '../../radio/style';
import '../../button/style';
